import Vue from 'vue'
import VueI18n from 'vue-i18n'

import messages from './translations';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: navigator.language.split('-')[0],
    messages
});

export default i18n;
